import axios from 'axios';

const getAllStaff = () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/api/staff`)
    .then(res => res)
    .catch(err => err);
};

export default getAllStaff;
